import { Card, CardContent, CardHeader } from '@mui/material';
import { useRef } from 'react';

import LoadingIndicator from '@/components/LoadingIndicator';

import useStyles from './GenericChartWidget.styles';
import type { GenericChartWidgetProps } from './GenericChartWidget.types';

const GenericChartWidget = (props: GenericChartWidgetProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const { title, loading, onCardClick, children, headerRightContent } = props;

  const { classes } = useStyles();

  return (
    <Card
      onClick={() =>
        onCardClick && title && typeof title === 'string'
          ? onCardClick(title)
          : null
      }
      className={classes.genericChartWidgetCard}
    >
      {title && (
        <CardHeader
          className={classes.genericChartWidgetCardHeader}
          title={title}
          action={headerRightContent}
        />
      )}
      <CardContent ref={ref} className={classes.genericChartWidgetCardContent}>
        {loading && (
          <div className={classes.genericChartWidgetChartLoading}>
            <LoadingIndicator noBackground isLoading={loading} />
          </div>
        )}
        {!loading && (
          <div className={classes.genericChartWidgetChart}>{children}</div>
        )}
      </CardContent>
    </Card>
  );
};

GenericChartWidget.displayName = 'GenericChartWidget';

export default GenericChartWidget;
